export const calculateBmi = (weight: number, length: number): number =>
	(weight / length / length) * 10000
